<template>
  <div>
    <v-row
      class="text-center pt-16 pb-12 white--text"
      style="background: linear-gradient(180deg, rgba(255,157,157,1) 5%, rgba(215,81,81,1) 50%, rgba(175,31,31,1) 93%);.curved {
  position: relative;
  border-bottom-left-radius: 20% 20%;
  border-bottom-right-radius: 20% 20%;
}"
    >
      <v-col cols="12">
        <v-img
          src="@/assets/logofinalw.png"
          contain
          height="240px"
          style="text-shadow: 6px,6px,6px;"
        />
      </v-col>

      <v-col class="">
        <h1 class="text-h3 text-md-h1 font-weight-bold mb-3">
          Welcome to Student City
        </h1>
        <p class="text-h5 text-md-h4 font-weight-regular">
          The home of student accommodatation in South Africa
        </p>
      </v-col>
      <v-col class="px-12 mt-0 pt-0" cols="12">
        <v-row class="mx-auto justify-center" >
        <v-col cols="12" md="4">
          <v-card class="text-center elevation-4">
    <v-row class="mx-auto">
        <v-col cols="6" md="4">
            <v-img 
                :class="{ 'hovered': hoverImage1 }"
                @mouseover="hoverImage1 = true"
                @mouseout="hoverImage1 = false"
                max-height="148px" 
                style="border-radius: 12px; box-shadow: 2px 2px 4px;"
                position="bottom" 
                src="@/assets/garanRooms/room1.jpg">
            </v-img>
        </v-col>
        <v-col cols="6" md="4">
            <v-img 
                :class="{ 'hovered': hoverImage2 }"
                @mouseover="hoverImage2 = true"
                @mouseout="hoverImage2 = false"
                max-height="148px" 
                style="border-radius: 12px; box-shadow: 2px 2px 4px;"
                position="bottom" 
                src="@/assets/garanRooms/room2.jpg">
            </v-img>
        </v-col>
        <v-col class="hidden-sm-and-down" cols="6" md="4">
            <v-img 
                :class="{ 'hovered': hoverImage3 }"
                @mouseover="hoverImage3 = true"
                @mouseout="hoverImage3 = false"
                max-height="148px" 
                style="border-radius: 12px; box-shadow: 2px 2px 4px;"
                position="bottom" 
                src="@/assets/garanRooms/room4.jpg">
            </v-img>
        </v-col>
    </v-row>
    <v-card-subtitle class="mt-3 text-center text-h5 text-md-h3 font-weight-bold primary--text" >
        Garankuwa - Quick Link Application
    </v-card-subtitle>
    <v-card-text class="mt-2" style="color:darkslategray"> 
        Discover the best rooms in Garankuwa and apply instantly.
    </v-card-text>
    <v-card-actions class="justify-center ">
        <v-btn large color="#90CAF9" class="mb-2 pulse-button  font-weight-black" href="https://forms.gle/HoaukTvwPGkVx4yc6" target="_none">Apply Here</v-btn>
    </v-card-actions>
</v-card>
        </v-col>

  </v-row>
</v-col>
      <v-col cols="12" v-show="false">
        <p>
          <span class="font-weight-bold" style="color: red">Contractor?</span>
          Join our mailing list for new opportunities
        </p>
        <v-text-field
        dark
          style="max-width: 640px"
          name="email"
          outlined
          label="E-mail address"
          hint="john@doe.com"
          id="id"
          class="mb-0 pb-0 mx-auto"
        ></v-text-field>
        <v-btn
          @click="contractorEmail"
          large
          class="red lighten-2 mt-0 ot-0 white--text"
          >Join</v-btn
        >
      </v-col>
      <v-slide-y-transition mode="in-out">
        <v-col cols="12" v-if="emailDone">
          <h2>Thanks for submitting your email</h2>
          <p class="font-weight-bold" style="color: firebrick">
            Great! Thank you for joining us, keep an eye out for brand new
            opportunities and offers.
          </p>
        </v-col>
      </v-slide-y-transition>
    </v-row>
<v-container>
    <v-divider class="mt-16 mb-8" />
    <div class="text-h3 text-center">Academic Systems</div>
    <div class="text-body-1 text-center mb-4">
      We cater to many different academic outfits, below are some we are extra
      proud of
    </div>
    <v-row class="mx-md-8 pb-6" justify="space-around" align="center">
      <v-col fills cols="auto" class="d-flex">
        <v-card class="pa-4 card__hover"
          ><v-img
            max-width="96px"
            src="https://my.nsfas.org.za/assets/images/nsfas_logo.png"
            ><template v-slot:placeholder>
              <div class="d-flex align-center justify-center fill-height">
                <v-progress-circular
                  indeterminate
                  color="grey-lighten-4"
                ></v-progress-circular>
              </div> </template></v-img
        ></v-card>
      </v-col>
      <v-col cols="auto" class="d-flex">
        <v-card class="pa-4 card__hover"
          ><v-img
            max-width="96px"
            src="https://upload.wikimedia.org/wikipedia/en/thumb/4/49/Tshwane_University_of_Technology_logo.svg/1200px-Tshwane_University_of_Technology_logo.svg.png"
            ><template v-slot:placeholder>
              <div class="d-flex align-center justify-center fill-height">
                <v-progress-circular
                  indeterminate
                  color="grey-lighten-4"
                ></v-progress-circular>
              </div> </template></v-img
        ></v-card>
      </v-col>
      <v-col cols="auto" class="d-flex">
        <v-card class="pa-4 card__hover"
          ><v-img max-width="96px" src="@/assets/smu.png"
            ><template v-slot:placeholder>
              <div class="d-flex align-center justify-center fill-height">
                <v-progress-circular
                  indeterminate
                  color="grey-lighten-4"
                ></v-progress-circular>
              </div> </template></v-img
        ></v-card>
      </v-col>
      <v-col cols="auto" class="d-flex">
        <v-card class="pa-4 pl-6 card__hover"
          ><v-img
            max-width="96px"
            style="border-radius: 0px"
            src="data:image/png;base64,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"
          >
            <template v-slot:placeholder>
              <div class="d-flex align-center justify-center fill-height">
                <v-progress-circular
                  indeterminate
                  color="grey-lighten-4"
                ></v-progress-circular>
              </div>
            </template> </v-img
        ></v-card>
      </v-col>
      <v-col cols="auto" class="d-flex">
        <v-card class="pa-4 card__hover"
          ><v-img
            max-width="96px"
            src="https://uniappsa.com/wp-content/uploads/2021/11/Taletso-Image-11_0.jpg"
          ></v-img
        ></v-card>
      </v-col>
      <v-col cols="auto" class="d-flex">
        <v-card class="pa-4 card__hover"
          ><v-img
            contain
            style="border-radius: 0px"
            max-width="96px"
            src="@/assets/snc.png"
          >
            <template v-slot:placeholder>
              <div class="d-flex align-center justify-center fill-height">
                <v-progress-circular
                  indeterminate
                  color="grey-lighten-4"
                ></v-progress-circular>
              </div>
            </template> </v-img
        ></v-card>
      </v-col>
    </v-row>
    <v-divider class="mb-16 mt-4" />
    <v-row class="mt-md-16 mx-0 px-0">
      <v-col cols="12" sm="6">
        <v-hover>
          <template v-slot:default="{ hover }">
            <v-card
              elevation="10"
              style="border-radius: 16px"
              color="red darken-2"
            >
              <v-img
                max-height="250"
                src="https://arcarchitects.co.za/wp-content/uploads/2022/07/Entrance-1-Close-Up-Night-scaled.jpg"
              ></v-img>
              <v-card-title
                class="mb-0 pb-0 "
                ><h1 class="text-h6 white--text font-weight-black text-md-h4">Garankuwa Heights</h1></v-card-title
              >
              <v-card-text class="white--text">
                <div class="mb-2 font-italic">*TUT Garankuwa, SMU, and other.</div>
                <div
                  class="text-decoration-underline font-weight-black text-h6"
                >
                  Description
                </div>
                <div class="text-body-1">
                  Garankuwa Heights is a growing student accommodation community
                  offering over 200 beds for students. With comfortable and
                  affordable living, residents have access to all the local
                  amenities they need. An added bonus is the outdoor gym,
                  providing a space for residents to stay fit and healthy.
                  Whether you're seeking a quiet place to study or a lively
                  community to be a part of, Garankuwa Heights has it all. Join
                  this dynamic community and make the most of your college
                  experience.
                </div>
              </v-card-text>
              <v-fade-transition>
                <v-overlay v-if="hover" absolute color="grey" class="text-center">
                  <v-btn class="red" to="/garankuwa">See more info</v-btn> <br/>
                  <v-btn class="red darken-2 mt-2 font-weight-bold" href="https://forms.gle/HoaukTvwPGkVx4yc6" target="_none">Apply Now!</v-btn>
                </v-overlay>
              </v-fade-transition>
            </v-card>
          </template>
        </v-hover>
      </v-col>
      <v-col cols="12" sm="6">
        <v-hover>
          <template v-slot:default="{ hover }">
            <v-card
              elevation="10"
              style="border-radius: 16px"
              color="red darken-2"
            >
              <v-img
                max-height="250"
                src="https://media-cdn.tripadvisor.com/media/photo-s/0e/45/a6/ee/mafikeng-museum.jpg"
              ></v-img>
              <v-card-title
                class="mb-0 pb-0 white--text font-weight-black font-italic text-h6 text-md-h4"
                >Mafikeng
                <span class="text-subtitle-1">(Name - TBD)*</span></v-card-title
              >
              <v-card-text class="white--text">
                <div class="mb-2 font-italic">*UNISA, NWU, Nurses College</div>
                <div
                  class="text-decoration-underline text-h6 font-weight-black"
                >
                  Description
                </div>
                <div class="text-body-1">
                  Located in the bustling city of Mafikeng, this student housing
                  complex offers 10,000 beds for students seeking comfortable
                  and convenient living. With a range of amenities including
                  recreational spaces, study areas, and 24/7 security, this
                  student housing provides an ideal living environment for those
                  pursuing their education. With its central location, students
                  have easy access to the city's top universities and cultural
                  attractions. Whether you're looking for a quiet space to study
                  or a vibrant community to be a part of, this student housing
                  has it all.
                </div>
              </v-card-text>
              <v-fade-transition>
                <v-overlay v-if="hover" absolute class="text-center" color="grey">
                  <h2 class="text--white display-3">Coming soon</h2>
                </v-overlay>
              </v-fade-transition>
            </v-card>
          </template>
        </v-hover>
      </v-col>
    </v-row>
    <v-row justify="center" align="center" class="my-16 pb-8">
      <v-img
        class="mx-auto mt-16 hidden-sm-and-down"
        max-height="320px"
        contain
        eager
        src="@/assets/ellipse53345.png"
      ></v-img>
    </v-row>
    <v-row justify="center" align="center" class="mt-16 mb-0 pb-0 text-center">
      <v-col class="text-center mb-0 pb-0" style="max-width: fit-content">
        <v-card
          elevation="10"
          style="border-radius: 16px; background-color: firebrick"
          class="pa-4"
        >
          <h1 class="text-h2 font-weight-black white--text px-4">About us</h1>
        </v-card>
      </v-col>
    </v-row>
    <v-row
      style="margin-top: -36px; border-radius: 16px"
      class="red pt-16"
      justify="center"
      align="center"
    >
      <v-card
        style="border-radius: 8px; max-width: 1080px"
        elevation="10"
        class="mx-4 mb-12 pa-auto"
      >
        <v-row justify="center" align="center" class="py-md-12 px-md-4 pt-4">
          <v-col cols="12" md="6">
            <v-card-title
              style="word-break: break-word"
              class="mt-0 pt-0 "
              ><h1 class="text-h2 font-weight-bold">The <span style="color: red">Best</span> for our
              students</h1></v-card-title
            >
            <v-card-text class="text-body-1"
              >StudentCity - Your Home Away from Home. Founded to meet the
              growing demand for quality student housing, our goal is to provide
              students with safe, accessible and comfortable living spaces. With
              a focus on safety, accessibility and affordability, StudentCity is
              dedicated to making your transition to university life seamless.
              Book your student housing today and experience the ultimate
              student living experience!</v-card-text
            >
          </v-col>
          <v-col
            style="border-radius: 8px !important"
            cols="12"
            md="6"
            class="pa-4 px-md-16"
          >
            <v-img
              style="border-radius: 8px"
              contain
              max-width="80vw"
              eager
              class="mx-auto"
              src="https://images.unsplash.com/photo-1622554129902-bb01970e2540?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=580&q=80"
            ></v-img>
          </v-col>
        </v-row>
        <v-divider />
        <v-row class="my-4" justify="center" align="center">
          <v-col class="px-md-16" cols="12" md="6">
            <v-img
              style="border-radius: 8px"
              eager
              max-width="80vw"
              class="mr-md-auto ml-md-8 mx-auto"
              src="https://images.unsplash.com/photo-1624567644499-c9df255d150b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=580&q=80"
            ></v-img
          ></v-col>
          <v-col cols="12" md="6">
            <v-card-title
              style="word-break: break-word"
              class="mt-4 pt-0"
              ><div>
                <h1 class="text-h2 font-weight-bold">Helping our students <span style="color: red">Strive</span></h1>
              </div>
            </v-card-title>
            <v-card-text class="text-body-1"
              >At StudentCity, we go above and beyond to provide a comprehensive
              student living experience. Our accommodations range from shared
              apartments to private rooms, all designed with the modern student
              in mind. We also offer a convenient transportation service to and
              from college, making it easy for you to get to your classes on
              time. And for those late-night cravings, we have a well-stocked
              kiosk where you can buy non-perishables. All our rooms are
              equipped with essential amenities and our staff is always on hand
              to assist with anything you may need. Come see why StudentCity is
              the perfect home away from home for students.
            </v-card-text>
          </v-col>
        </v-row>
      </v-card>
    </v-row>
    <v-img
      eager
      src="@/assets/path4333.png"
      class="mx-auto mb-16"
      max-width="300px"
    ></v-img>
    <v-row style="min-height: 75vh">
      <v-col cols="12" class="text-left text-md-center">
        <v-divider />
        <h1 class="pt-16 text-h2">Our Statistics</h1>
      </v-col>
      <v-col cols="12" md="6">
        <div>
          <h2 class="text-h3">Housing a student, one bed at a time</h2>
          <div class="text-body-1 mt-4 ml-md-1">
            At StudentCity, we understand the importance of data in making
            informed decisions. That's why we use statistical analysis to
            continually improve our student housing services and offerings. By
            analyzing usage patterns, student feedback, and other relevant data,
            we can make informed decisions about everything from room design to
            amenities and services. This helps us provide the best possible
            student living experience and ensure that our accommodations meet
            the evolving needs and preferences of today's students.
          </div>
        </div>
      </v-col>
      <v-col cols="12" md="6">
        <v-row v-view.once="onceHandler" justify="center" align="center">
          <v-col class="text-center" md="4">
            <v-progress-circular
              class="mb-2"
              :size="100"
              :width="15"
              :rotate="-90"
              :value="valueSec"
              color="primary"
            >
              {{ valueSec }}%
            </v-progress-circular>
            <br />
            <h1 class="font-weight-bold">Security Presence</h1>
          </v-col>
          <v-col class="text-center" md="4">
            <v-progress-circular
              :size="100"
              :width="15"
              :rotate="-45"
              :value="valueRating"
              color="accent"
              class="mb-2"
            >
              {{ valueRating }}%
            </v-progress-circular>
            <br />
            <h1 class="font-weight-bold">Room Ratings</h1>
          </v-col>
          <v-col class="text-center" md="4">
            <v-progress-circular
              :size="100"
              :width="15"
              :rotate="0"
              :value="valueSatisfaction"
              color="secondary"
              class="mb-2"
            >
              {{ valueSatisfaction }}%
            </v-progress-circular>
            <br />
            <h1 class="font-weight-bold">Student Satisfaction</h1>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</div>
</template>

<script>
export default {
  name: "HelloWorld",

  data() {
    return {
      emailGiven: false,
      intervalSatisfaction: {},
      intervalRating: {},
      valueSatisfaction: 0,
      valueRating: 0,
      valueSec: 0,
      intervalSec: {},
      windowTop: 0,
      emailDone: false,
      hoverImage1: false,
        hoverImage2: false,
        hoverImage3: false,
    };
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    removeThankyou() {
      this.emailDone = false;
    },
    contractorEmail() {
      this.emailGiven = true;
      this.emailDone = true;
      setTimeout(this.removeThankyou, 5000);
    },

    onceHandler() {
      this.intervalSatisfaction = setInterval(() => {
        if (this.valueSatisfaction <= 95) {
          return (this.valueSatisfaction += 2);
        }
      }, 30);
      this.intervalRating = setInterval(() => {
        if (this.valueRating <= 93) {
          return (this.valueRating += 2);
        }
      }, 25);
      this.intervalSec = setInterval(() => {
        if (this.valueSec <= 98) {
          return (this.valueSec += 2);
        }
      }, 20);
    },
  },
  mounted() {
    window.addEventListener("scroll", function () {
      this.windowTop = window.scrollY;
    });
  },
};
</script>
<style>
.v-img__img {
  max-width: 200px;
}
.v-card {
  border-radius: 16px !important;
}
.card__hover {
  transform: scale(1);
  transition: transform 0.2s ease;
}
.card__hover:hover {
  transform: scale(1.2);
}
.card__hover:hover > v-img {
  transform: scale(1.8);
}
.hovered {
    transform: scale(1.05);
    transition: transform .2s;
}
@keyframes pulse {
    0% {
        transform: scale(1);
        color: #90CAF9;
    }
    50% {
        transform: scale(1.05);
        color: #42A5F5;
    }
    100% {
        transform: scale(1);
        color: #90CAF9;
    }
}
.pulse-button {
    animation: pulse 1s infinite;
}
.text-h1, .text-h2, .text-h3, .text-h4, .text-h5, .text-h6, .text-subtitle-1, .text-subtitle-2, .text-body-1, .text-body-2, .text-caption, .text-overline {
    font-family: 'Nunito', sans-serif !important;
}

</style>
